export default __webpack_public_path__ + "static/media/scheduler.ef88da69.png";